import React, { useEffect, useState } from "react";
import ContainerDefault from "../../components/ContainerDefault";
import { Radio, Popover, Space, Divider } from "antd";
import { LabelPadrao, InputPadrao, SemDados, CheckBoxPadrao, EyeIcon, ModalPadrao } from "../../components/Base";
import { fetch } from "../../actions";
import TabelaPadrao from "../../components/TabelaPadrao";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import dayjs from "dayjs";
import { DownOutlined } from "@ant-design/icons";
import CollapseMovimentacao from "./CollapseMovimentacao";
import toLocale from "../../Utils/ToLocaleString";
import { connect } from "react-redux";
import SelectFiltros from "../../components/Selects/SelectFiltros";
import { BtnDetalhe, BtnEdit, BtnListar, BtnSair } from "../../components/Buttons";
import VendaDetalhe from "../Venda/VendaDetalhe";
import Lancamento from "../Lancamento/Lancamento";
import ContasDetalhe from "../Contas/ContasDetalhe";
import { useValidarUsuario } from "../../components/Hooks/useValidarUsuario";
import { useHistory } from "react-router-dom";
import { formatarCorPorValorMovimentacao } from "../../Utils/utils";

function Movimentacao(props) {
  const history = useHistory();
  const [validar, validando] = useValidarUsuario(props.fetch);
  const [filtros, setFiltros] = useState({ dtIni: dayjs(), formato: null, venda: true, canc: true, entrada: true, saida: true, pagamento: true, recebimento: true, pessoa: null, numNf: null });
  const [dados, listar, loading] = useFetch(() => api.getAll(props.fetch, filtros));
  const [detalhe, setDetalhe] = useState({});

  useEffect(() => validar("acessarMovimentos", null, () => setFiltros({ ...filtros, formato: "det" }), () => history.push("/")), []);

  useEffect(() => {
    if (!!filtros.formato)
      listar();

  }, [filtros.formato]);

  const columns = [
    {
      Header: "Data/Hora",
      accessor: "data",
      tipo: "dthr",
      Footer: `(${dados?.length})`
    },
    {
      Header: "Tipo",
      accessor: "tipo",
      Cell: props => <span style={{ color: formatarCorPorValorMovimentacao(props.row.original.valor) }}>{props.row.original.tipo}</span>
    },
    {
      Header: "Número",
      accessor: "numero",
    },
    {
      Header: "Nota fiscal",
      accessor: "nf"
    },
    {
      Header: "Cliente / Histórico",
      accessor: "historico",
      Cell: props => <span>{(!!props.row.original.pessoa && props.row.original.tipo == "Venda" && props.row.original.valor > 0) ? props.row.original.pessoa : props.row.original.historico}</span>
    },
    {
      Header: "Valor",
      accessor: "valor",
      Cell: props => <span style={{ color: formatarCorPorValorMovimentacao(props.row.original.valor) }}>{toLocale(props.row.original.valor)}</span>,
      tipo: "right"
    },
    {
      Header: "Saldo",
      accessor: "saldo",
      tipo: "right",
      Cell: props => <span style={{ color: formatarCorPorValorMovimentacao(props.row.original.saldo) }}>{toLocale(props.row.original.saldo)}</span>
    },
    {
      Header: " ",
      accessor: " ",
      tipo: "right",
      Cell: props => {
        let comp = null;
        if (props.row.original.contaFinId)
          comp = <BtnDetalhe small id="icon" onClick={() => setDetalhe({ id: props.row.original.contaFinId, tipo: "conta" })} />;
        else if (props.row.original.vendaId)
          comp = <BtnDetalhe small id="icon" onClick={() => setDetalhe({ id: props.row.original.vendaId, tipo: "venda" })} />;
        else if (props.row.original.tipo == "Lançamento")
          comp = <BtnDetalhe small id="icon" onClick={() => setDetalhe({ id: props.row.original.id, tipo: "lancamento" })} />;

        return <td className="td-icon">{comp}</td>;
      }
    },
  ];

  return <>
    <ContainerDefault loading={loading || validando} online={props.online}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>

        <p style={{ opacity: 0.7, margin: "25px 0", fontSize: "1.1rem" }}>Caixa Movimentação</p>
        <div style={{ width: "90%", margin: "auto" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "50%", marginRight: 10 }}>
              <LabelPadrao noMargin>Cliente</LabelPadrao>
              <InputPadrao placeholder="Insira o cliente" value={filtros.pessoa} onChange={v => setFiltros({ ...filtros, pessoa: v.target.value })} />
            </div>
            <div style={{ width: "50%" }}>
              <LabelPadrao noMargin>Número/NF</LabelPadrao>
              <InputPadrao placeholder="Insira o número" value={filtros.numNf} onChange={v => setFiltros({ ...filtros, numNf: v.target.value })} />
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end", margin: "10px auto" }}>
            <div style={{ width: "50%", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <SelectFiltros style={{ flex: 1, marginRight: 10 }} title="Caixas" placeholder="Selecione o caixa" modelo="caixa" value={filtros?.caixaDiaId} onChange={v => setFiltros({ ...filtros, caixaDiaId: v })} allowClear alwaysFetch />
            </div>

            <div style={{ width: "50%", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <div style={{ marginLeft: 10 }}>
                <LabelPadrao>Filtrar movimento:</LabelPadrao>

                <Radio.Group style={{ display: "flex", marginTop: 5 }} value={filtros.formato} onChange={v => setFiltros({ ...filtros, formato: v.target.value })}>
                  <Radio value="det">Detalhado
                    <Popover placement="bottom" content={<Space direction="vertical">
                      <CheckBoxPadrao checked={filtros.venda} onChange={() => setFiltros({ ...filtros, venda: !filtros.venda })}>Venda</CheckBoxPadrao>
                      <CheckBoxPadrao checked={filtros.canc} onChange={() => setFiltros({ ...filtros, canc: !filtros.canc })}>Cancelamento</CheckBoxPadrao>
                      <CheckBoxPadrao checked={filtros.entrada} onChange={() => setFiltros({ ...filtros, entrada: !filtros.entrada })}>Lan. Entrada</CheckBoxPadrao>
                      <CheckBoxPadrao checked={filtros.saida} onChange={() => setFiltros({ ...filtros, saida: !filtros.saida })}>Lan. Saída</CheckBoxPadrao>
                      <CheckBoxPadrao checked={filtros.recebimento} onChange={() => setFiltros({ ...filtros, recebimento: !filtros.recebimento })}>Recebimento</CheckBoxPadrao>
                      <CheckBoxPadrao checked={filtros.pagamento} onChange={() => setFiltros({ ...filtros, pagamento: !filtros.pagamento })}>Pagamento</CheckBoxPadrao>
                    </Space>} trigger="hover" > <DownOutlined style={{ margin: "0 10px" }} /></Popover>
                  </Radio>
                  <Radio value="mod">Modalidade</Radio>
                  <Radio value="tipo">Tipo</Radio>
                </Radio.Group>

              </div>
              <BtnListar style={{ marginLeft: 10 }} onClick={listar} />
            </div>
          </div>
        </div>
        {filtros.formato === "det" && <TabelaPadrao columns={columns} data={dados} style={{ marginTop: 25 }} />}
        {((filtros.formato === "mod" || filtros.formato === "tipo") && !!dados?.length) ? <CollapseMovimentacao dados={dados} /> : <>{(filtros.formato === "mod" || filtros.formato === "tipo") && <SemDados style={{ marginTop: 50 }} />}</>}
      </div>
    </ContainerDefault>

    <ModalPadrao visible={detalhe.tipo == "venda"} footer={<BtnSair onClick={() => setDetalhe({})} />} onCancel={() => setDetalhe({})} width={900}>
      <VendaDetalhe id={detalhe?.id} isLocal onCancel={() => setDetalhe({})} onOk={() => { setDetalhe({}); listar(); }} />
    </ModalPadrao>

    <Lancamento id={detalhe.tipo == "lancamento" ? detalhe.id : null} onOk={() => setDetalhe({})} onCancel={() => setDetalhe({})} />

    <ContasDetalhe id={detalhe.tipo == "conta" ? detalhe.id : null} onCancel={() => setDetalhe({})} />
  </>;
}

const mapStateToProps = state => ({ online: state.connection.online, usuarioId: state.auth.userId });

export default connect(mapStateToProps, { fetch })(Movimentacao);